import React from "react";

const AllergyDetail = ({ handleAllergyInfo }) => (
  <div className="rest-alt-info">
    <h5>Please contact the restaurant directly to check for allergen and dietary information before placing an order.</h5>
    <p>
      If you are ordering alcohol, proof of age will be required for anyone looking under the age of 25.
    </p>
    <ul className="d-flex align-items-center justify-content-between">
      <li>
        <span>V</span>
        <span>Vegatarian</span>
      </li>
      <li>
        <span>VE</span>
        <span>Vegan DF</span>
      </li>
      <li>
        <span>DF</span>
        <span>Daily Free</span>
      </li>
      <li>
        <span>GF</span>
        <span>Gluten Free</span>
      </li>
      <li className="active">
        <span>E</span>
        <span>Local E Exclusive Discount</span>
      </li>
    </ul>
  </div>
);

export default AllergyDetail;
